import { createAsyncThunk } from '@reduxjs/toolkit';
import * as sentApi from '../../api/sentapi';

export const getSentAll = createAsyncThunk('getSentAll', async (data) => {
    const res = await sentApi.getSentAll({ data: data });
    return res.data;
});
